class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M9.5 15h-3v-1h3v-2h-2a1 1 0 0 1-.706-.294A1 1 0 0 1 6.5 11V9a1.001 1.001 0 0 1 1-1h3v1h-3v2h2a.999.999 0 0 1 1 1v2a.997.997 0 0 1-1 1Zm5-7-.76 2.5-.24.989-.229-.989L12.5 8h-1v7h1v-4l-.08-1 .291 1 .789 2.314.791-2.314.289-1-.08 1v4h1V8h-1Z"></path><path d="M9.5 1a1 1 0 0 1 .997.923L10.5 2v.206a5.5 5.5 0 0 1 3.998 5.149H13.5a4.506 4.506 0 0 0-3-4.1V6.5h-1V2h-3v4.5h-1V3.254a4.5 4.5 0 0 0-3 4.112V9.5l3-.003V10.5H2a.498.498 0 0 0-.497.44L1.5 11v.191a.5.5 0 0 0 .337.472l.057.017 3.606.771v1.023l-3.817-.817A1.506 1.506 0 0 1 .5 11.283V11c0-.654.417-1.211 1-1.417V7.5a5.5 5.5 0 0 1 4-5.294V2a1 1 0 0 1 .923-1H9.5Z"></path></svg>';
  }
}
const a = "pi-safety-manager";
customElements.get(a) || customElements.define(a, t);
export {
  t as default
};
